const {debounce} = require('./util/debounce');

export default () => jQuery(($) => {

	const mains = $('.stat__main--has-alongside');

	const statUpdate = function(){
		mains.each(function(){
			const number = $(this).find('.stat__number');
			const alongside = $(this).find('.stat__alongside');
            if(number.hasClass('stat__number--stacked')) {
                number.removeClass('stat__number--stacked');
            }
            if(alongside.hasClass('stat__alongside--stacked')) {
                alongside.removeClass('stat__alongside--stacked');
            }
			if(number.position().top < alongside.position().top) {
                number.addClass('stat__number--stacked');
                alongside.addClass('stat__alongside--stacked');
			}
		});
	};

	const statRecheck = debounce(function () {
		statUpdate();
	}, 400);

	statUpdate();

    $(window).load(function () {
        statUpdate();
    });
    $(window).resize(function () {
        statUpdate();
    });
});
